var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPortals = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: 24,
  viewBox: "0 0 24 24",
  width: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m22.17 17.874c-.576 1.002-1.86 1.344-2.862.768s-1.344-1.86-.768-2.862 1.86-1.344 2.862-.768c1.008.582 1.35 1.86.768 2.862z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m5.45401 8.21999c-.576 1.002-1.86 1.344-2.862.768s-1.344-1.86-.768-2.862 1.86-1.344 2.862-.768c1.002.582 1.344 1.86.768 2.862z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m1.83 17.874c-.576-1.002-.234-2.28.768-2.862 1.002-.576 2.28-.234 2.862.768.576 1.002.234 2.28-.768 2.862-1.008.576-2.286.234-2.862-.768z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m18.546 8.21999c-.576-1.002-.234-2.28.768-2.862 1.002-.576 2.28-.234 2.862.768.576 1.002.234 2.28-.768 2.862-1.002.576-2.286.234-2.862-.768z",
  fill: "currentColor"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m12 23.748c-1.158 0-2.09399-.936-2.09399-2.094s.93599-2.094 2.09399-2.094 2.094.936 2.094 2.094c0 1.152-.936 2.094-2.094 2.094z",
  fill: "currentColor"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m12 4.43999c-1.158 0-2.09399-.936-2.09399-2.094s.93599-2.093999 2.09399-2.093999 2.094.935999 2.094 2.093999-.936 2.094-2.094 2.094z",
  fill: "currentColor"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "m12 1.5 4.3301 7.5 1.0826 1.875.2706.4688.1353.2343"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.6603 16.5h-8.6603-2.16506-.54126-.27064-.13531"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.33975 7h8.66025 2.1651.5412.2707.1353"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 22-4.33012-7.5-1.08253-1.875-.27064-.4688-.13531-.2343"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.6602 7-4.3301 7.5-1.0825 1.875"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.58734 16.375 4.33013-7.5 1.08253-1.875"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.0365 1.72787 8.6603 5v10.00003l-8.6603 5-8.66026-5v-10.00003z"
}))));
export default SvgPortals;